import axios from "../axios-auth";
import orginal_axios from "axios";

export const productionPlanService = {
    getProductionPlanList,
    saveProductionPlan,
    getProductionPlanDetail,
    getProductionPlanExcelExport,
};

function getProductionPlanList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.description) {
        params["description"] = searchParams.description;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (typeof (searchParams.isAddDetails) == 'boolean') {
        params["isAddDetails"] = searchParams.isAddDetails;
    }
    if (typeof (searchParams.isAddUnits) == 'boolean') {
        params["isAddUnits"] = searchParams.isAddUnits;
    }

    return axios.get("/auth/production-plans", { params });
}

function saveProductionPlan(ProductionPlan) {
    if (!ProductionPlan.id) {
        // new 
        return axios.post("/auth/production-plan", ProductionPlan);
    } else {
        // edit
        return axios.put("/auth/production-plan", ProductionPlan);
    }
}

function getProductionPlanDetail(id) {
    return axios.get("/auth/production-plan/" + id);
}

function getProductionPlanExcelExport(searchParams) {
    let params = {};
  
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.description) {
        params["description"] = searchParams.description;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (typeof (searchParams.isAddDetails) == 'boolean') {
        params["isAddDetails"] = searchParams.isAddDetails;
    }
    if (typeof (searchParams.isAddUnits) == 'boolean') {
        params["isAddUnits"] = searchParams.isAddUnits;
    }
  
    return orginal_axios({
      method: "GET",
      url: axios.defaults.baseURL + "/auth/production-plan-excel-export",
      params,
      responseType: "arraybuffer", // important
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    }).then(function (response) {
      return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
  }
